import { useState } from 'react'
import PropTypes from 'prop-types'

const Tooltip = ({ text, children, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false)

  const getPositionClasses = () => {
    const baseClasses =
      'absolute z-50 px-2.5 py-1.5 bg-black z-10 text-white text-sm rounded w-max max-w-[350px] whitespace-wrap'
    switch (position) {
      case 'top':
        return `${baseClasses} bottom-full left-1/2 -translate-x-1/2 mb-1`
      case 'bottom':
        return `${baseClasses} top-full left-1/2 -translate-x-1/2 mt-1`
      case 'left':
        return `${baseClasses} right-full top-1/2 -translate-y-1/2 mr-1`
      case 'right':
        return `${baseClasses} left-full top-1/2 -translate-y-1/2 ml-1`
      default:
        return baseClasses
    }
  }

  const getArrowPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2'
      case 'bottom':
        return 'top-full mt-1 left-1/2 -translate-x-1/2 -translate-y-1/2'
      case 'left':
        return 'right-0 top-1/2 -translate-y-1/2 translate-x-1/2'
      case 'right':
        return 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/2'
      default:
        return ''
    }
  }

  return (
    <div
      className="relative inline-block cursor-pointer"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onTouchStart={() => setIsVisible(true)}
      onTouchEnd={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={`absolute w-2 h-2 bg-black/80 rotate-45 ${getArrowPositionClasses()}`}
        ></div>
      )}
      {isVisible && <div className={getPositionClasses()}>{text}</div>}
    </div>
  )
}

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
}
export default Tooltip
